module.exports = __webpack_public_path__ + "src/assets/img/lock-white.ef7bbcca.svg";